// extracted by mini-css-extract-plugin
module.exports = {"wrap":"MarketplaceLinks_wrap__BZ8ag","title":"MarketplaceLinks_title___Uxch","buttonsWrap":"MarketplaceLinks_buttonsWrap__AR_uv","button":"MarketplaceLinks_button__Tgkaz"};